import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import Loader from "components/Loader"
import { pick, get } from "lodash"
import { Modal, Button, Progress } from "antd"
import check from "../../images/check.svg"

import {
  makeSelectSummary,
  makeSelectIsLoadingSummary,
  makeSelectPercentage,
} from "./selectors"
import {
  getSummaryWatcher,
  uploadTemplateWatcher,
  saveExcelWatcher,
} from "./actions"
import reducer from "./reducer"
import saga from "./saga"

import "./index.less"
import SummaryScreen from "./summary"

export function ActionPlansImportSummary(props) {
  const [modalProgress, setModalProgress] = useState(false)

  useEffect(() => {
    localStorage.setItem("currentMeasure", props.match.params.id_measure)
    props.getSummaryWatcher()
  }, [])

  const modalProgressImport = () => {
    return (
      <Modal
        visible={modalProgress}
        okText="Aceptar"
        closable={false}
        footer={
          props.percentage !== 100
            ? null
            : [
                <Button
                  key="submit"
                  type="primary"
                  onClick={() => {
                    setModalProgress(false)
                    props.history.push(`/action-plans`)
                  }}>
                  Aceptar
                </Button>,
              ]
        }
        width={520}>
        {props.percentage !== 100 ? (
          <div className="modalSuccess">
            <Progress
              style={{ margin: "0 auto" }}
              width={80}
              type="circle"
              percent={props.percentage}
            />
            <span
              style={{
                justifySelf: "center",
                alignSelf: "center",
                marginTop: "1em",
                fontSize: "14px",
                color: "#555151",
              }}>
              La importación puede tardar unos minutos...
            </span>
          </div>
        ) : (
          <div className="modalSuccess" style={{ textAlign: "center" }}>
            <img src={check} />
            <span style={{ marginTop: 14, fontWeight: 600, color: "#555151" }}>
              La importación ha sido completada con éxito.
            </span>
          </div>
        )}
      </Modal>
    )
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Importación de planes de acción</title>
      </Helmet>
      {props.isLoadingSummary ? (
        <Loader />
      ) : (
        <div className="ActionPlansImportSummary-screen">
          <SummaryScreen
            backTitle="Seguimiento"
            backModalTitle="¿Estás seguro de que deseas salir de la importación?"
            content={["plan_de_accion", "error", "row"]}
            gridHeader="1.5fr 1.5fr 40px"
            gridContent="1.5fr 1.5fr 40px"
            header={["Plan de acción", "Error", "Fila"]}
            hasUpdates={false}
            history={props.history}
            id={parseInt(props.match.params.id_measure)}
            maxWidthTable="85%"
            onFinalize={(params) => {
              params = {
                params,
                id_company: props.summary.company,
                id_measure: parseInt(props.match.params.id_measure),
                timestamp: props.summary.timestamp,
              }
              setModalProgress(true)
              props.saveExcelWatcher(params)
            }}
            typeImport="Importación"
            textResumeActionPlan={{
              text: "planes de acción",
              success: (
                <React.Fragment>
                  <span>{`${get(
                    props.summary,
                    "count_import_action_plan",
                    0
                  )} `}</span>
                  {`${plural(
                    "plan",
                    get(props.summary, "count_import_action_plan", 0),
                    "es"
                  )} ${plural(
                    "importado",
                    get(props.summary, "count_import_action_plan", 0),
                    "s"
                  )}`}
                </React.Fragment>
              ),
              failed: (
                <React.Fragment>
                  <span>{`${get(
                    props.summary,
                    "count_error_action_plan",
                    0
                  )} `}</span>
                  {`${plural(
                    "plan",
                    get(props.summary, "count_error_action_plan", 0),
                    "es"
                  )} sin importar`}
                </React.Fragment>
              ),
            }}
            textResumeTask={{
              text: "tareas",
              success: (
                <React.Fragment>
                  <span>{`${get(
                    props.summary,
                    "count_import_task",
                    0
                  )} `}</span>
                  {`${plural(
                    "tarea",
                    get(props.summary, "count_import_task", 0),
                    "s"
                  )} ${plural(
                    "importada",
                    get(props.summary, "count_import_task", 0),
                    "s"
                  )}`}
                </React.Fragment>
              ),
              failed: (
                <React.Fragment>
                  <span>{`${get(props.summary, "count_error_task", 0)} `}</span>
                  {`${plural(
                    "tarea",
                    get(props.summary, "count_error_task", 0),
                    "s"
                  )} sin importar`}
                </React.Fragment>
              ),
            }}
            title="planes de acción"
            uploadTemplate={props.uploadTemplateWatcher}
            urlBack={`/action-plans/import/${props.match.params.id_measure}`}
            hideFinalize={
              get(props.summary, "count_import_action_plan", 0) === 0
            }
            {...pick(props.summary, [
              "count_import",
              "count_error",
              "list_errors",
            ])}
          />
        </div>
      )}
      {modalProgressImport()}
    </React.Fragment>
  )
}

const mapStateToProps = createStructuredSelector({
  summary: makeSelectSummary(),
  isLoadingSummary: makeSelectIsLoadingSummary(),
  percentage: makeSelectPercentage(),
})

function mapDispatchToProps(dispatch) {
  return {
    getSummaryWatcher: () => dispatch(getSummaryWatcher()),
    uploadTemplateWatcher: (params) => dispatch(uploadTemplateWatcher(params)),
    saveExcelWatcher: (params) => dispatch(saveExcelWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "actionPlansImportSummary", reducer })
const withSaga = injectSaga({ key: "actionPlansImportSummary", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(ActionPlansImportSummary)
